import { render, staticRenderFns } from "./doctorPatients.vue?vue&type=template&id=e14d53a0&"
import script from "./doctorPatients.vue?vue&type=script&lang=js&"
export * from "./doctorPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e14d53a0')) {
      api.createRecord('e14d53a0', component.options)
    } else {
      api.reload('e14d53a0', component.options)
    }
    module.hot.accept("./doctorPatients.vue?vue&type=template&id=e14d53a0&", function () {
      api.rerender('e14d53a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/doctor/doctorPatients.vue"
export default component.exports